import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/shared/app.config';

@Injectable({
  providedIn: 'root'
})
export class PseudoSsnApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig
  ) { }

  generate() {
    return this.http.get<{ nextval: string | number }>(this.config.generatePseudoSsnUrl).pipe(
      map(response => String(response.nextval))
    );
  }
}